import dataReducer from './data.reducer';

export default dataReducer;
